<script setup lang="ts">
import { registerVariantQueryKey } from '@/components/templates/RegisterUserTemplate/useRegisterValiant';
import NuxtLinkFlat from 'theme/components/atoms/NuxtLinkFlat.vue';

defineProps<{
  plannerId: string;
}>();

const route = useRoute();
const isExclusive = computed(() =>
  Object.prototype.hasOwnProperty.call(route.query, 'exclusive')
);
const isQRMatching = computed(() => route.query.inflow_source === 'qr');
const hasRegisterVariant = computed(
  () => registerVariantQueryKey in route.query
);
</script>

<template>
  <div :class="[$style.wrapper__footer, $style.footer]">
    <NuxtLinkFlat
      :to="{
        path: `/planner/${plannerId}/matching`,
        query: {
          ...(isExclusive ? { exclusive: null } : {}),
          ...(isQRMatching ? { inflow_source: 'qr' } : {}),
          ...(hasRegisterVariant
            ? {
                [registerVariantQueryKey]: route.query[registerVariantQueryKey],
              }
            : {}),
        },
      }"
      :class="[$style.footer__button, $style['footer__button--matching']]"
      variant="primary"
    >
      このプランナーにチャット相談
    </NuxtLinkFlat>
  </div>
</template>

<style lang="scss" module>
.footer {
  position: sticky;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 36px;
  height: 74px;
  bottom: 0;
  width: 100%;
  background-color: $color-surface-accent-primary-light;
  gap: 16px;
  padding: 0 12px;

  @include tablet-upper {
    gap: 32px;
  }

  &__button {
    text-align: center;
    flex-basis: 200px;
    padding-left: 1em;
    padding-right: 1em;

    &--matching {
      flex-basis: 343px;
    }
  }
}
</style>
